import { ShekarChanceReport } from "../../../Interfaces/orderInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";
import { ITableUI } from "../../TableTemplate/tableTemplate";

export const HuntChancesTableUI: React.FC<ITableUI<ShekarChanceReport>> = ({
  reports,
  onAction,
}: ITableUI<ShekarChanceReport>) => {
  return <CommonTableUI reports={reports} onAction={onAction} />;
};
